/**
 * getStreamForContent
 * @description return stream which `id` matches with content's `id`, otherwise return the first stream item
 * @param content
 * @returns {Stream}
 */
export default function getStreamForContent(content) {
    const { id, streams = [] } = content;
    let stream = streams.filter(streamItem => streamItem.id === id)[0];
    if (!streams) {
        stream = streams[0];
    }
    return stream;
}



// WEBPACK FOOTER //
// ./app/lib/format/getStreamForContent.js